import Button from "@builder/components/general/Button";
import "./style.scss";
import { useAppDispatch } from "@builder/store/store";
import { setCurrentPopup, setImageState } from "@builder/store/slices/popupSlice";

const ImagePlacholder = () => {
    const dispatch = useAppDispatch();
    const addImageSrc = () => {
        dispatch(setImageState(null));
        dispatch(setCurrentPopup("images"));
    };
    return (
        <div className="image-placeholder">
            <Button buttonStyle="secondary" className="add-img-src" onClick={addImageSrc} icon={{ src: "/paperclip-icon.svg" }} />
        </div>
    );
};

export default ImagePlacholder;
